import React, { useState } from "react";
import styles from "./AddSchedule.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";

import { FaRegFileAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import CalendarInput from "../../components/CalendarInput/CalendarInput";


const AddSchedule = () => {

    const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    shiftName: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    staff: "",
    rooms: "",
    categories: "",
    lessons: "",
    days: "",
  });

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCancel = () => {
    setFormData({
      shiftName: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      staff: "",
      rooms: "",
      categories: "",
      lessons: "",
      days: "",
    });
   
  };
  

  const handleSave = () => {
    console.log("Form Data:", formData);
    // Handle save logic here
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaRegFileAlt />} heading="Add Schedule" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.section}>
        <div className={styles.heading}>
          <HeadingAndIcon icon={<FaRegFileAlt />} heading="Schedule Details" />
        </div>
        <div className={styles.content}>
          <div className={styles.formGrid}>
            <HeadingAndData
              label="Shift Name"
              name="shiftName"
              placeholder="Enter shift name"
              value={formData.shiftName}
              onChange={handleChange}
              required
            />
            <CalendarInput
              fieldLabel="Start date"
              value={formData.startDate}
              onChange={(val) => handleDateChange("startDate", val)}
              required
            />
            <CalendarInput
              fieldLabel="End date"
              value={formData.endDate}
              onChange={(val) => handleDateChange("endDate", val)}
              required
            />

            <HeadingAndData
              label="Start Time"
              name="startTime"
              type="time"
              value={formData.startTime}
              onChange={handleChange}
              required
            />
            <HeadingAndData
              label="End Time"
              name="endTime"
              type="time"
              value={formData.endTime}
              onChange={handleChange}
              required
            />
            <HeadingAndDropDown
              label="Rooms"
              name="rooms"
              value={formData.rooms}
              onChange={handleChange}
              options={[
                { label: "Room 1", value: "room1" },
                { label: "Room 2", value: "room2" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Staff"
              name="staff"
              value={formData.staff}
              onChange={handleChange}
              options={[
                { label: "John", value: "john" },
                { label: "Jane", value: "jane" },
              ]}
            />
            <HeadingAndDropDown
              label="Categories"
              name="categories"
              value={formData.categories}
              onChange={handleChange}
              options={[
                { label: "Academic", value: "academic" },
                { label: "Sports", value: "sports" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Lessons"
              name="lessons"
              value={formData.lessons}
              onChange={handleChange}
              options={[
                { label: "Math", value: "math" },
                { label: "English", value: "english" },
              ]}
              required
            />
            <HeadingAndDropDown
              label="Days"
              name="days"
              value={formData.days}
              onChange={handleChange}
              options={[
                { label: "Monday", value: "Monday" },
                { label: "Tuesday", value: "Tuesday" },
                { label: "Wednesday", value: "Wednesday" },
                { label: "Thursday", value: "Thursday" },
                { label: "Friday", value: "Friday" },
              ]}
              required
            />
          </div>

          <div className={styles.actions}>
            <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSchedule;
